import { createContext } from "preact";
import { ContentBlockServiceInterface } from "../interfaces/content-block.interface";

export const ContentBlockServiceContext = createContext<ContentBlockServiceInterface | null>(null)